import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {ContractualDataModel} from '../../../../models/ContractualDataModel';
import {NumAnnoMeseFilterComponent} from '../../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {RegionFilterComponent} from '../../../general-components/filter/region-filter/region-filter.component';
import {LocalCustomerFilterComponent} from '../../../general-components/filter/local-customer-filter/local-customer-filter.component';
import {ContractTypeFilterComponent} from '../../../general-components/filter/contract-type-filter/contract-type-filter.component';
import {Sl1FilterComponent} from '../../../general-components/filter/sl1-filter/sl1-filter.component';
import {ChargingMethodologyFilterComponent} from '../../../general-components/filter/charging-methodology-filter/charging-methodology-filter.component';
import {ResourceUnitFilterComponent} from '../../../general-components/filter/resource-unit-filter/resource-unit-filter.component';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {Offset} from '../../../../models/Offset';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {ContractualValuesService} from '../../contractual-values/service-contractual-values/contractual-values.service';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import {ProviderAnagrafService} from '../../../general-services/service-provider-anagraf/provider-anagraf.service';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {ContractTypeService} from '../../../general-services/service-contract-type/contract-type.service';
import {Sl1AnagrafService} from '../../../general-services/service-sl1-services/sl1-anagraf.service';
import {ResourceUnitService} from '../../../general-services/service-resources-units-anagraf/resource-unit.service';
import {MatDialog} from '@angular/material';
import {UserModel} from '../../../../models/UserModel';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../../general-components/dialog-year-month/dialog-year-month.component';
import * as toastr from 'toastr';
import * as FileSaver from 'file-saver';
import {ChargingMethodologyModel} from '../../../../models/ChargingMethodologyModel';
import {BaseGeneralComponent} from "../../../BaseGeneralComponent";

@Component({
  selector: 'app-filter-arc-rrc',
  templateUrl: './filter-arc-rrc.component.html',
  styleUrls: ['./filter-arc-rrc.component.scss']
})
export class FilterArcRrcComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() showNewEditDelete?: boolean;
  @Input() numAnnoMeseData?: any;
  @Input() contractTypeData?: any;
  @Input() chargingMethData?: any;
  @Input() filter?: ContractualDataModel;
  @Input() reportSection?: boolean;

  regionData: any;
  localCustomerData: any;
  designServiceData: any;
  resourceUnitData: any;

  @Output() dataFiltered = new EventEmitter<any>();

  @ViewChild(NumAnnoMeseFilterComponent) numAnnoFilterComponent;
  @ViewChild(RegionFilterComponent) regionFilterComponent;
  @ViewChild(LocalCustomerFilterComponent) localCustomerFilterComponent;
  @ViewChild(ContractTypeFilterComponent) contractTypeFilterComponent;
  @ViewChild(Sl1FilterComponent) designServicesFilterComponent;
  @ViewChild(ChargingMethodologyFilterComponent) chargingMethodologyFilterComponent;
  @ViewChild(ResourceUnitFilterComponent) resourceUnitFilterComponent;

  filterSingle: AllSettingsFilterModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  dataSource: any;
  intermittentBool: boolean;

  constructor(private loaderService: LoaderService,
              private contractualValuesService: ContractualValuesService,
              private numAnnoMeseService: NumAnnoMeseService,
              private providerService: ProviderAnagrafService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService,
              private contractTypeService: ContractTypeService,
              private sl1AnagrafService: Sl1AnagrafService,
              private resourceUnitService: ResourceUnitService,
              private dialog: MatDialog) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new ContractualDataModel();
    }
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filter.contractType = this.contractTypeData[0];
    this.filterSingle = AllSettingsFilterModel.getFromContractualDataModel(this.filter);
    this.offset = new Offset(10, 0);
    if (this.showNewEditDelete === undefined) {
      let user: UserModel;
      this.showNewEditDelete = true;
      user = JSON.parse(sessionStorage.getItem('user'));
      this.filter.region = user.regionList[0];
      this.filterSingle.region = user.regionList[0];
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {
    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      allSettingsFilterModel
    ).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllResourceUnitObservable: Observable<any> = this.resourceUnitService.getAll(
      this.resourceUnitService.baseUrl,
      allSettingsFilterModel).pipe();

    forkJoin([getAllRegionObservable, getAllLocalCustomerObservable,
      getAllDesignServicesObservable, getAllResourceUnitObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.designServiceData = resultFork[2];
          this.resourceUnitData = resultFork[3];

          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptRegionChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitObservable: Observable<any> = this.resourceUnitService.getAll(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllDesignServicesObservable);
    observableList.push(getAllResourceUnitObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.designServiceData = resultFork[2];
          this.resourceUnitData = resultFork[3];

          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.designServices = this.filterSingle.sl1;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitObservable: Observable<any> = this.resourceUnitService.getAll(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllDesignServicesObservable);
    observableList.push(getAllResourceUnitObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.designServiceData = resultFork[2];
          this.resourceUnitData = resultFork[3];

          this.filter.region = this.filterSingle.region;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.designServices = this.filterSingle.sl1;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptContractTypeChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.contractType = event;

    /** const getAllNumAnnoMeseFilteredObservable: Observable<any> = this.numAnnoMeseService.getAllMonth(
     this.filterSingle.contractType).pipe(); **/
    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle
    ).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitObservable: Observable<any> = this.resourceUnitService.getAll(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();


    // observableList.push(getAllNumAnnoMeseFilteredObservable);
    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllDesignServicesObservable);
    observableList.push(getAllResourceUnitObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          // this.numAnnoMeseData = resultFork[0];
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.designServiceData = resultFork[2];
          this.resourceUnitData = resultFork[3];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.designServices = this.filterSingle.sl1;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          /** if (!BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
            const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
            this.filter.numAnnoMese = numAnnoMese;
          } **/

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptDesignServicesChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.sl1 = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitObservable: Observable<any> = this.resourceUnitService.getAll(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllResourceUnitObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];
          this.resourceUnitData = resultFork[3];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptResourceUnitChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.resourceUnit = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];
          this.designServiceData = resultFork[3];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.designServices = this.filterSingle.sl1;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptNumAnnoMeseChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.ARC_RRC_FILTER, JSON.stringify(this.filter));
    }
    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const isReset = true;
    this.filter = new ContractualDataModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filterSingle = AllSettingsFilterModel.getFromContractualDataModel(this.filter);

    this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).subscribe(
      (resultContractType: any) => {
        this.contractTypeData = resultContractType;
        this.filter.contractType = this.contractTypeData[0];
        this.numAnnoMeseService.getAllMonth(this.filter.contractType).subscribe(
          (resultYearMonth: any) => {
            this.numAnnoMeseData = resultYearMonth;

            const numAnnoMese = resultYearMonth[0] ? resultYearMonth[0] : null;
            this.filter.numAnnoMese = numAnnoMese;

            const chargingMethData = new ChargingMethodologyModel(this.CHARGING_METHODOLOGY.ARC_RRC);
            this.filter.chargingMethodology = chargingMethData.value;
            this.filter.chargingMethodologyObject = chargingMethData;

            sessionStorage.setItem(this.SESSION_STORAGE_LABELS.ARC_RRC_FILTER, JSON.stringify(this.filter));
            this.filterSingle = AllSettingsFilterModel.getFromContractualDataModel(this.filter);

            this.initFilter(this.filterSingle, isReset);
          }, error => {
            console.log(error);
            this.loaderService.display(false);
          });
      });

  }

  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.contractualValuesService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.contractualValuesService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();
    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.CONTRACTUAL_VALUES_SERVICE}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
    }
    this.filter.localCustomer = this.localCustomerFilterComponent.optionSelected;
    this.filter.region = this.regionFilterComponent.optionSelected;
    this.filter.contractType = this.contractTypeFilterComponent.optionSelected;
    this.filter.designServices = this.designServicesFilterComponent.optionSelected;
    this.filter.resourceUnit = this.resourceUnitFilterComponent.optionSelected;
    this.filter.numAnnoMeseFrom = this.numAnnoFilterComponent.optionSelected;
    this.filter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
  }

  ngOnDestroy(): void {

  }
}
